import classNames from "classnames";
import "./progressStatus.scss";

interface CrumbProps {
    percentage: number;
    status: boolean;
}

interface ProgressStatus extends CrumbProps{
    text?: string;
}

interface ProgressStatusProps {
    statuses: ProgressStatus[];
}

export const Crumb = ({status, percentage}: CrumbProps) => {
    return (
        <div className={classNames("crumb-item" , {"-active": status})}>
            <span className="percentage-txt">
                {`${percentage}%`}
            </span>
        </div>
    )
}

export const ProgressStatus = ({statuses}: ProgressStatusProps) => {
    return (
        <div className="progress-status-wrapper">
            {statuses.map(({status, percentage, text}) => 
                <div className={classNames("crumb-wrapper", {"-active": status})}>
                    <div className="crumb-inner">
                        <Crumb percentage={percentage} status={status}/>
                        <strong>{text}</strong>
                    </div>
                </div>
            )}
        </div>
    )
}